import {
  EmailConfigurator,
  SingleSelectionConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const BudgetCenterOneTimeUserSurveyConfig = (options) => {
  const { i18n } = options;

  return {
    featureArea: 'BudgetCenterOneTimeUserSurvey',
    style: {
      root: {
        minWidth: 600,
        maxWidth: 600,
      },
    },
    others: {
      shouldHideInputWhenNotSelected: true,
    },
    questions: [
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Why didn’t you return to Budget Center after your first visit? Please select one.')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('I didn\'t find the information I was looking for.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The page was difficult to navigate.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('The features weren’t useful.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('I prefer to use other tools for budget and spend management.')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Others - please specify')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 1024,
          },
        ],
        data: {
        },
      },
      {
        isRequired: true,
        Type: SingleSelectionConfigurator,
        key: 'q2',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('What would encourage you to use Budget Center more frequently?')),
        isVisible: () => true,
        options: [
          {
            key: 'q2o1',
            text: i18n.getString(_TL_('Clearer navigation and ease of use')),
          },
          {
            key: 'q2o2',
            text: i18n.getString(_TL_('More relevant and useful features, such as forecasting')),
          },
          {
            key: 'q2o3',
            text: i18n.getString(_TL_('More detailed information and instructions')),
          },
          {
            key: 'q2o4',
            text: i18n.getString(_TL_('Others - please specify')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 1024,
          },
        ],
        data: {
        },
      },
    ],
    email: {
      isRequired: true,
      Type: EmailConfigurator,
      key: 'email',
      page: 1,
      position: 1,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: () => true,
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes - specify the contact email below')),
          placeholder: i18n.getString(_TL_('Enter your email')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
  };
};
